import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState } from 'react';
import UserOnglet from "../../user/UserOnglet";
import UserGoBack from "../../user/UserGoBack";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicPhone = () => {
  const { setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const isSmallDevise = windowWidth < 900;  

  if (isLoading) return <LoadingComponent />;
  
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous devez modifier votre numéro de téléphone ? Aucun problème. 
              Garder votre numéro de téléphone à jour est un bon moyen de protéger votre compte.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Modifier le numéro de téléphone depuis un ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Profil</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Informations personnelles.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Accédez à la section <strong>Numéro de téléphone</strong>, cliquez sur <strong>Modifier</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Effectuez vos modifications, puis cliquez sur <strong>Enregistrer</strong>.</p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Modifier le numéro de téléphone depuis navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyez sur <strong>Profil</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Informations personnelles.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Accédez à la section <strong>Numéro de téléphone</strong>, appuyez sur <strong>Modifier</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Effectuez vos modifications, puis appuyez sur <strong>Enregistrer</strong>.</p></li>
                    </ol>
                  </div>
              }
              <p className="help-text mt-32">
                Votre numéro de téléphone ne sera pas visible par les autres athlètes et autres utilsateurs.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicPhone